// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2fXGS","search":"Settings_search__1-Y11","filter":"Settings_filter__2CpH1"};